export default __webpack_public_path__ + "static/B0260-404f64d1d6eb27f4987c55dea4fa01c4.png";